'use client';
import type { HelloBars } from '@/types';

import { Container, Link, Text } from '@/components';

const BoxHelloBar = ({ data }: { data: HelloBars }): React.ReactElement => {
  return (
    <>
      <Container
        width="100%"
        background="complimentary.5"
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingInline="20px"
        paddingBlock="10px"
      >
        <Text
          fontSize={{ base: 'xs', xl: 'md' }}
          fontWeight="700"
          textAlign="center"
        >
          {data.title}
        </Text>
      </Container>
    </>
  );
};

const HelloBar: React.FC<{ data: HelloBars }> = ({ data }) => {
  return (
    <>
      {data.link ? (
        <Link href={data.link} target="_blank">
          <BoxHelloBar data={data} />
        </Link>
      ) : (
        <BoxHelloBar data={data} />
      )}
    </>
  );
};
export default HelloBar;
